export default function formatNumber(num, precision) {
  const order = Math.floor(Math.log10(num));
  if (order < 0) {
    precision = 10 ** order / 10;
  }
  const rounded = Math.round(num / precision) * precision;
  return rounded.toString().slice(0, Math.abs(order) + 3);
}
